import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {cloudLightest} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  containerReport: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: indent,
  },
  base: {
    backgroundColor: cloudLightest,
    width: '100%',
    paddingVertical: 4,
    paddingHorizontal: indent,
  },
  report: {
    flex: 1,
    marginRight: indent,
  },
  filterSort: {
    flexDirection: 'row',
    gap: indent * 0.2,
  },
});
